<template>
  <v-card flat>
    <!-- check query -->
    <!-- {{ auth($route.query) }} -->
    <!-- <v-card-title v-if="$route.query">{{ $route.query }}</v-card-title>
    <v-card-text></v-card-text>
    <v-card-actions v-if="$route.query">
      <v-btn @click="auth($route.query)">Add</v-btn>
    </v-card-actions>-->
    <v-data-table v-if="items" :headers="headers" :items="items" hide-default-footer>
      <template v-slot:top>
        <v-card-title>
          <v-icon>mdi-telegram</v-icon>
          <span class="headline ml-3">Trade by Telegram</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined :href="link()">/login @Telegram</v-btn>

          <v-tooltip right color="transparent">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" icon v-on="on">
                <v-icon color="primary">mdi-information</v-icon>
              </v-btn>
            </template>
            <v-card width="300">
              <v-card-title>Telegram Terminal</v-card-title>
              <v-card-text>You must install Telegram on Desktop or Smart Phone to authorize your Telegram.</v-card-text>
            </v-card>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.account="{ item }">
        <v-select
          v-model="item.accountId"
          :items="accounts"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
        ></v-select>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          small
          class="mr-2"
          icon
          :loading="item.id == itemLoading"
          @click="addAccount(item)"
        >
          <v-icon>save</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          small
          icon
          :loading="item.id + 'del' == itemLoading"
          @click="del(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
// import ApiService from "@/common/api.service";

import { mapGetters } from "vuex";
import { TERMINAL } from "@/store/actions.type";

export default {
  name: "TelegramTerminal",
  props: {
    accounts: {
      type: null,
      default: null
    },
    terminals: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      items: null,
      itemLoading: null,
      headers: [
        {
          text: "Telegram",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Account", value: "account" },
        { text: "Actions", value: "actions" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser", "errors"])
  },
  watch: {
    terminals(terminals) {
      this.buildItems(terminals);
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been rendered
      this.auth(this.$route.query);
    });
    this.buildItems(this.terminals);
  },
  methods: {
    buildItems(terminals) {
      if (terminals) {
        this.items = terminals.filter(terminal => terminal.type === "telegram");
      } else {
        this.$store.dispatch(TERMINAL.FETCH, this.currentUser.id);
      }
    },
    link() {
      return "tg://resolve?domain=".concat(
        process.env.VUE_APP_TERMINAL_TELEGRAM_NICKNAME
      );
    },
    add(telegramData, accountId) {
      this.itemLoading = telegramData.id;
      let terminal = {
        id: "telegram." + telegramData.id,
        type: "telegram",
        name: telegramData.username,
        accountId: accountId,
        userId: this.currentUser.uid
      };
      this.$store.dispatch(TERMINAL.CREATE, terminal).then(() => {
        this.$store.dispatch(TERMINAL.FETCH, this.currentUser.id).then(() => {
          this.itemLoading = null;
        });
      });
    },
    addAccount(terminalData) {
      this.itemLoading = terminalData.id;
      this.$store.dispatch(TERMINAL.EDIT, terminalData).then(() => {
        this.$store.dispatch(TERMINAL.FETCH, this.currentUser.id).then(() => {
          this.itemLoading = null;
        });
      });
    },
    del(item) {
      this.itemLoading = item.id + "del";
      this.$store.dispatch(TERMINAL.DEL, item).then(() => {
        this.$store.dispatch(TERMINAL.FETCH, this.currentUser.id).then(() => {
          this.itemLoading = null;
        });
      });
    },
    auth(data) {
      // https://tradingif.com/terminals?id=661595321&first_name=Ha&last_name=Do&username=hajdo&auth_date=1588349717&hash=ed282f1239c9eb0aae4b55879d842ee5a814e0f1c34f302dcaf2c3012ced5da8
      // data = this.$route.query;
      // console.log(data);
      if (data.hash) {
        this.$store.dispatch(TERMINAL.TELEGRAM_DECODE, data).then(result => {
          if (result.data) {
            this.add(data, null);
          }
        });
      }
    }
  }
};
</script>

<style></style>
